import React, { useState } from 'react'
import _ from 'lodash'

import { Badge, IconButton, Menu, MenuItem, Typography } from '@material-ui/core'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'

import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import NotesIcon from '@material-ui/icons/Notes'
import StarIcon from '@material-ui/icons/Star'

import { formatDate } from 'utils/masks'
import { NOTIF_TYPE, notificationsList } from 'utils/constants/notifications'

import styles from './styles'

export default () => {
  const classes = styles()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const renderNotifIcon = (notif) => {
    switch (notif.type) {
      case NOTIF_TYPE.DOC:
        return <NotesIcon />
      case NOTIF_TYPE.FEAT:
        return <StarIcon />
      default:
        return null
    }
  }

  const renderNotifItem = (notif) => {
    return (
      <MenuItem key={notif.id} onClick={notif.action}>
        <ListItemIcon>
          {renderNotifIcon(notif)}
        </ListItemIcon>
        <ListItemText className={classes.notifTextContainer}>
          <Typography className={classes.notifTitle}>{notif.title}</Typography>
          <Typography className={classes.notifDescription}>{notif.description}</Typography>
          <Typography className={classes.notifCreatedAt}>{formatDate(notif.created_at, { hideHour: true })}</Typography>
        </ListItemText>
      </MenuItem>
    )
  }

  const renderNotifsList = () => {
    return _
      .chain(notificationsList)
      .sortBy(['created_at'])
      .reverse()
      .map(notif => renderNotifItem(notif))
      .value()
  }

  const renderMenu = () => {
    return (
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClick={handleClose}
        onClose={handleClose}
      >
        {renderNotifsList()}
      </Menu>
    )
  }

  return (
    <React.Fragment>
      <IconButton
        aria-label="notifications"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Badge badgeContent={0}>
          <NotificationsNoneIcon />
        </Badge>
      </IconButton>

      {renderMenu()}
    </React.Fragment>
  )
}
